import Vue from 'vue'
import Router from 'vue-router'
// import Main from './component/Main.vue'
// import Businesses from './component/Businesses.vue'
import Transactions from './component/Transactions.vue'
import Customers from './component/Customers.vue'
import Analytics from './component/Analytics.vue'
import Logs from './component/Logs.vue'
/*
import Shows from './component/Shows.vue'
import Business from './component/Business.vue'
import Payments from './component/Payments.vue'
import Settings from './component/Settings.vue'
*/
import Courtesies from './component/Courtesies.vue'
import Indicators from './component/Indicators.vue'
/* import ShowCase from './component/ShowCase.vue'
import EventDates from './component/EventDates.vue'
import EventDate from './component/EventDate.vue'
import Producers from './component/Producers.vue' */
import Products from './component/Products.vue'
import Signatures from './component/Signatures.vue'

Vue.use(Router)

// Resolve NavigationDuplicated
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/transaction'
    },
    /* {
      path: '/event-dates',
      name: 'event-dates',
      component: EventDates
    },
    {
      path: '/event-dates/:id',
      name: 'event-date',
      component: EventDate,
      props: true
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Main
    },
    {
      path: '/business',
      name: 'businesses',
      component: Businesses
    },
    {
      path: '/business/:id',
      name: 'business',
      component: Business,
      props: true
    }, */
    {
      path: '/transaction',
      name: 'transaction',
      component: Transactions
    },
    {
      path: '/updates',
      name: 'updates',
      component: Indicators
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customers
    },
    {
      path: '/customer/:id',
      name: 'customer',
      component: Customers,
      props: true
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics
    },
    {
      path: '/log',
      name: 'logs',
      component: Logs
    },
    /* {
      path: '/show',
      name: 'shows',
      component: Shows
    },
    {
      path: '/payment',
      name: 'payments',
      component: Payments
    }, */
    /* {
      path: '/settings',
      name: 'settings',
      component: Settings
    }, */
    {
      path: '/courtesy',
      name: 'courtesy',
      component: Courtesies
    },
    {
      path: '/courtesy/:id',
      name: 'courtesy',
      component: Courtesies,
      props: true
    },
    /*
    {
      path: '/showcase',
      name: 'showcase',
      component: ShowCase
    },
    {
      path: '/producer',
      name: 'producers',
      component: Producers
    },
    {
      path: '/producer/:id',
      name: 'producer',
      component: Producers,
      props: true
    }, */
    {
      path: '/product',
      name: 'products',
      component: Products
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Products,
      props: true
    },
    {
      path: '/signature',
      name: 'signatures',
      component: Signatures
    },
    {
      path: '/signature/:id',
      name: 'signature',
      component: Signatures,
      props: true
    }
  ]
})
